// List of plaid bank provider names that obfuscate their data
export const OBFUSCATING_PLAID_BANK_PROVIDERS = [
  "JPMorgan - NY's 529 Advisor Guided",
  'Chase',
  'Empower Retirement - JPMorgan Asset Management',
  'JP Morgan - Altman Investment Management',
  'JP Morgan - Fisher Investments',
  'JP Morgan UK Pension Plan',
];
